import { AdvancedCareTeamMember } from '../../api/types'

export type RoleCategoryId = string

export type RoleCategory = { id: RoleCategoryId; label: string }

// A local display preference; membership itself comes from `care_team_members`.
export type CareTeamTemplate = {
  categoryIds: RoleCategoryId[]
}

export type CategoryGroup = { categoryId: RoleCategoryId; members: AdvancedCareTeamMember[] }

export const labelForMember = (categoryLabel: string, indexInCategory: number): string =>
  indexInCategory <= 0 ? categoryLabel : `${categoryLabel} ${indexInCategory + 1}`

const PRIORITY_ROLE_IDS = ['psychiatrist', 'therapist', 'nutritionist', 'care-coordinator']

const rolePriority = (id: RoleCategoryId): number => {
  const index = PRIORITY_ROLE_IDS.indexOf(id)
  return index === -1 ? PRIORITY_ROLE_IDS.length : index
}

export const groupMembersByCategory = (
  templateCategoryIds: RoleCategoryId[],
  members: AdvancedCareTeamMember[]
): CategoryGroup[] => {
  const order: RoleCategoryId[] = []
  const seen = new Set<RoleCategoryId>()
  const addCategory = (id: RoleCategoryId) => {
    if (!seen.has(id)) {
      seen.add(id)
      order.push(id)
    }
  }
  templateCategoryIds.forEach(addCategory)
  members.forEach((member) => addCategory(member.role))

  order.sort((a, b) => rolePriority(a) - rolePriority(b) || a.localeCompare(b))

  return order.map((categoryId) => ({
    categoryId,
    members: members
      .filter((member) => member.role === categoryId)
      .sort((a, b) => a.startedAt.localeCompare(b.startedAt)),
  }))
}
